export default __webpack_public_path__ + "static/media/nightSky.5a869117.jpg";